import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Tabs } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from './auth';
import './index.css';

const API_BASE = '';

function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/login', values);
      const data = res.data;
      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('username', data.user.username);
        localStorage.setItem('user_id', data.user.id);
        localStorage.setItem('nickname', data.user.nickname || data.user.username);
        message.success('登录成功');
        navigate('/');
        window.location.reload();
      } else {
        message.error(data.error || '登录失败');
      }
    } catch (err) {
      const errMsg = err.response?.data?.error || '网络错误，请稍后重试';
      message.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Decorative shapes */}
      <div className="login-shape-top" />
      <div className="login-shape-bottom" />

      <Card
        className="login-card"
        bordered={false}
      >
        <div className="login-title">
          <div className="login-logo">AI</div>
          <h1>AI试穿短视频生成器</h1>
          <p>登录后即可使用全部功能</p>
        </div>

        <Tabs
          centered
          items={[
            {
              key: 'login',
              label: '登录',
              children: (
                <Form onFinish={handleLogin} layout="vertical">
                  <Form.Item
                    name="username"
                    rules={[{ required: true, message: '请输入用户名' }]}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="用户名"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: '请输入密码' }]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="密码"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block size="large">
                      登录
                    </Button>
                  </Form.Item>
                </Form>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
}

export default Login;